import { render, staticRenderFns } from "./CheckMaintenanceHistory.vue?vue&type=template&id=3cb22610&scoped=true&"
import script from "./CheckMaintenanceHistory.vue?vue&type=script&lang=ts&"
export * from "./CheckMaintenanceHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb22610",
  null
  
)

export default component.exports